import * as types from '../actionsTypes/timbraturaActionsType';
import {datiRegistroActions, loadingOverlayActions, notifsActions} from "../index";
import {createMessageRequestException} from "../../fanctionUtility";
import new_axios_instance from '../../axios_instance';

export const initTimbrature = () => ({
    type: types.INIT_TIMBRATURE
});

//***************************************** Action Timbrature per Presenze Giorno Corrente ***************************************

export const ricercaTimbratureSingoloIndividuoAction = (idCorso, tab) => ({
    type: types.RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_ACTION,
    payload: {idCorso, tab}
});

export const ricercaTimbratureSingoloIndividuoEnd = (timbrature, error) => ({
    type: types.RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_END,
    timbrature, error
})

//************************************** Fine Action Timbrature per Presenze Giorno Corrente ****************************************

//************************************** Timbrature Manuali **************************************************************

export const addTimbraturaManualeAction = (datiTimbratura, tab, type, cbReload) => ({
    type: types.ADD_TIMBRATURA_MANUALE_ACTION,
    payload: {datiTimbratura, tab, type, cbReload}
});


export const addTimbraturaManualeEnd = (errors = []) => ({
    type: types.ADD_TIMBRATURA_MANUALE_END,
    errors
});

export const addTimbraturaAutomaticaEnd = (errors = []) => ({
    type: types.ADD_TIMBRATURA_AUTOMATICA_END,
    errors
});

export const invertiTimbraturaAction = (datiTimbratura) => ({
    type: types.INVERTI_TIMBRATURA,
    payload: {datiTimbratura}
})

//************************************** Timbrature Manuali **************************************************************

//************************************** Cancella Timbratura Manuale **************************************************************

export const invertiTimbratura = (param, tab) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(invertiTimbraturaAction())
    await new_axios_instance.post(`/v1/timbratura/inverti/${param.id}`)
    .then(() => {
        dispatch(notifsActions.notifSuccess(`Operazione avvenuta con successo`));
        dispatch(datiRegistroActions.initResocontoMeseReducer());
        dispatch(datiRegistroActions.ricercaTimbratureStartPerRegistroAction([param], tab));
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    })
    .catch(error => {
        const message = createMessageRequestException(error);
        dispatch(notifsActions.notifError(message));
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    });
}

export const deleteTimbratura = (param, tab) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(deleteTimbraturaAction());
    await new_axios_instance.delete(`/v1/timbratura/elimina/${param.id}`)
        .then(() => {
            dispatch(notifsActions.notifSuccess(`Operazione avvenuta con successo`));
            dispatch(datiRegistroActions.initResocontoMeseReducer());
            dispatch(datiRegistroActions.ricercaTimbratureStartPerRegistroAction([param], tab));
            dispatch(getDeleteTimbraturaManualeSuccess());
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const message = createMessageRequestException(error);

            dispatch(notifsActions.notifError(message));
            dispatch(getDeleteTimbraturaManualeFail());
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};

export const deleteTimbraturaAction = () => ({
    type: types.DELETE_TIMBRATURA_ACTION
});

export const getDeleteTimbraturaManualeSuccess = () => ({
    type: types.DELETE_TIMBRATURA_SUCCESS
});

export const getDeleteTimbraturaManualeFail = () => ({
    type: types.ADD_TIMBRATURA_AUTOMATICA_FAIL
});

//************************************** Cancella Timbratura Manuale **************************************************************

export const recuperaDettaglioTimbratura = (idTimbratura) => {
    return new_axios_instance.get(`/v1/timbratura/recupera/${idTimbratura}`);
};

export const timbraturaValida = (idTimbratura) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.post(`/v1/timbratura/valida`, {id: idTimbratura})
        .then(() => {
            dispatch(notifsActions.notifSuccess(`Operazione avvenuta con successo`));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const message = createMessageRequestException(error);

            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
}

export const generaTimbrature = (idCorso, idAnagrafica, data, tab) => async dispatch => {
    sessionStorage.removeItem('validationCache');
    new_axios_instance.post(`/v1/timbratura/genera/singola`, {idCorso, idAnagrafica, data}).then(() => {
        dispatch(datiRegistroActions.initResocontoMeseReducer());
        dispatch(datiRegistroActions.ricercaTimbratureStartPerRegistroAction([{daData: data, aData: data, idCorso, idAnagrafica}], tab));
    })
}

export const generaTimbratureBulk = (idCorso, anagrafiche, data, tab) => {
    new_axios_instance.post(`/v1/timbratura/genera/bulk`, {idCorso, anagrafiche, data}).then(() => {
        window.location.href = window.location.href + "&open=true"
        window.location.reload()
    })
}